import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken } from "@/lib/api";
import { auth as fbAuth, onAuthStateChanged, signOut as fbSignOut } from "@/lib/firebase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/api/auth/me");
      setUser(data.user);
      return data.user;
    } catch {
      setUser(null);
      return null;
    }
  };

  useEffect(() => {
    // On first mount, check if we have a valid Splink session
    (async () => {
      await refreshMe();
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    // Sync with Firebase state; if firebase user disappears, log out splink too
    const unsub = onAuthStateChanged(fbAuth, async (fbUser) => {
      if (!fbUser) {
        // Do not force logout on missing fb user — user might have persisted Splink JWT
      }
    });
    return unsub;
  }, []);

  const exchangeIdToken = async (idToken) => {
    const { data } = await api.post("/api/auth/firebase/session", { id_token: idToken });
    if (data.token) setAuthToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/api/auth/logout"); } catch {}
    setAuthToken(null);
    try { await fbSignOut(); } catch {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, exchangeIdToken, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const v = useContext(AuthContext);
  if (!v) throw new Error("useAuth outside AuthProvider");
  return v;
}
